import styled from 'styled-components';

const ButtonOffset = styled('div')({
  marginTop: 40,
});

export { ButtonOffset };
